import AjaxService from '../services/ajax-service';

export const fetchNotifications = ({ offset = 0, limit = 15, unreadOnly = false, filters, triggeredBy }) => {
    return AjaxService({
        method: 'get',
        url: `notifications`,
        params: {
            limit,
            offset,
            unread_only: unreadOnly,
            filters: filters ? JSON.stringify(filters) : undefined,
            triggered_by: triggeredBy
        }
    }).then(response => response?.data);
}

export const removeNotifications = notifications_ids => {
    return AjaxService({
        method: 'delete',
        url: `notifications`,
        data: { notifications_ids }
    }).then(response => response?.data);
}

export const readNotifications = notifications_ids => {
    return AjaxService({
        method: 'post',
        url: `notifications/read`,
        data: { notifications_ids }
    }).then(response => response?.data);
}

export const unreadNotifications = notifications_ids => {
    return AjaxService({
        method: 'post',
        url: `notifications/unread`,
        data: { notifications_ids }
    }).then(response => response?.data);
}

export const readAllNotifications = () => {
    return AjaxService({
        method: 'post',
        url: `notifications/read-all`
    }).then(response => response?.data);
}
